import { Navigate } from "react-router-dom";
import { useDefaultLandingPage } from "../bridges/session";

/** Today's side of the Help addresses: today's Help is a pop-up with no address, so an address sends the person to their start page. */
export const LegacyHelpRedirect = () => <Navigate to={useDefaultLandingPage()} replace />;
